module.exports = __webpack_public_path__ + "img/flower.4dac5d53.svg";